import {
  DELETE_USER_TENANT_REQUEST,
  DELETE_USER_TENANT_SUCCESS,
  DELETE_USER_TENANT_FAILURE,
  DELETE_USER_TENANT_RESET,
} from '../../../Constants/actionTypes';

import { deleteUserTenantApi } from '../../../Constants/apiService';
import { fetchProfile } from './userProfileAction'; // you already have this

export const deleteUserTenantRequest = () => ({ type: DELETE_USER_TENANT_REQUEST });
export const deleteUserTenantSuccess = (data) => ({ type: DELETE_USER_TENANT_SUCCESS, payload: data });
export const deleteUserTenantFailure = (err) => ({ type: DELETE_USER_TENANT_FAILURE, payload: err });
export const deleteUserTenantReset   = () => ({ type: DELETE_USER_TENANT_RESET });

// ✅ thunk
export const deleteUserTenant = (tenantUrl) => {
  return async (dispatch, getState) => {
    dispatch(deleteUserTenantRequest());

    const accessToken = getState()?.auth?.accessToken;
    try {
      const res = await deleteUserTenantApi({ tenantUrl }, accessToken);
      dispatch(deleteUserTenantSuccess(res));

      // ✅ refresh profile so tenant list updates from server truth
      dispatch(fetchProfile());
    } catch (error) {
      const msg = error?.message?.includes('fetch')
        ? 'Unable to delete tenant. Please try again.'
        : (error?.message || 'Unable to delete tenant.');
      dispatch(deleteUserTenantFailure(msg));
    }
  };
};
